/**
 * PublishDialog — confirmation d'envoi du rapport au propriétaire : dépôt au coffre-fort (toujours) + courriel avec le PDF (optionnel) + message.
 */
import { useState } from "react";
import { Send } from "lucide-react";
import { Btn, Modal, inputCls } from "../../comptabilite/_shared";

export default function PublishDialog({ check, onClose, onConfirm, busy }) {
  const [sendEmail, setSendEmail] = useState(!!check.client_email);
  const [message, setMessage] = useState("");
  return (
    <Modal title="Envoyer le rapport au propriétaire" sub={`${check.client_name || "Propriétaire"} · dossier ${check.master_name || "—"}`} onClose={onClose} testId="tr-publish-dialog"
      footer={<>
        <Btn tone="slate" onClick={onClose} testId="tr-publish-cancel">Annuler</Btn>
        <Btn icon={Send} onClick={() => onConfirm({ send_email: sendEmail, message })} busy={busy} testId="tr-publish-confirm">Générer et envoyer</Btn>
      </>}>
      <ul className="text-xs text-slate-600 space-y-1 list-disc pl-4">
        <li>Le PDF final est généré avec votre logo et vos couleurs, sans pièces jointes.</li>
        <li>Il est déposé dans le <b>coffre-fort</b> du propriétaire (portail) et une notification lui est envoyée.</li>
        <li>L'enquête passe au statut <b>Terminée</b> si elle est encore en attente ; vous pouvez ensuite donner votre verdict (Accepté / Refusé).</li>
      </ul>
      <label className="flex items-center gap-2 text-sm">
        <input type="checkbox" checked={sendEmail} onChange={(e) => setSendEmail(e.target.checked)} disabled={!check.client_email} className="accent-teal-600" data-testid="tr-publish-email" />
        Envoyer aussi par courriel avec le PDF en pièce jointe {check.client_email ? <span className="text-slate-500">({check.client_email})</span> : <span className="text-rose-600">(aucun courriel au dossier)</span>}
      </label>
      {sendEmail && (
        <label className="block">
          <span className="block text-[11px] font-semibold text-slate-600 mb-1">Message personnel (optionnel)</span>
          <textarea rows={3} value={message} onChange={(e) => setMessage(e.target.value)} className={inputCls} maxLength={2000} placeholder="Ex. Voici le rapport demandé. N'hésitez pas à me contacter pour en discuter." data-testid="tr-publish-message" />
        </label>
      )}
    </Modal>
  );
}
